import IgnoreMenu from './view'

export default IgnoreMenu
